import { SCol, SRow } from '@avalara/skylab-sdk/react';
import type React from 'react';

import Subtext from './order-item-subtext';

type Props = {
  name: string | null | undefined;
  price: string;
  strikethrough?: boolean;
  subtext?: string;
  nameStyle?: React.CSSProperties;
  priceStyle?: React.CSSProperties;
};

const OrderItem = ({ name, price, strikethrough, subtext, nameStyle, priceStyle }: Props) => (
  <>
    <SRow className='pad-top-xs'>
      <SCol span='8' style={nameStyle}>
        {name}
      </SCol>
      <SCol
        data-ref='buy.order-summary.price'
        span='4'
        style={priceStyle}
        className={`text-right${strikethrough ? ' text-strikethrough' : ''}`}
      >
        <span>{price}</span>
      </SCol>
    </SRow>

    {subtext && (
      <SRow>
        <SCol>
          <Subtext text={subtext} />
        </SCol>
      </SRow>
    )}
  </>
);
export default OrderItem;
